import { SupabaseService } from "../../server/supabase/base-supabase-service";

export class AdditionalServicesService extends SupabaseService<"additional_service"> {
  table = "additional_service" as const;

  async getServicesInterest() {
    const rows = this.log_errors(
      await this.client.from("additional_service").select("*, account (id, name)"),
    );

    if (rows.error) return { error: rows.error, data: rows.data };
    const additionalServices = rows?.data ?? [];
    const userIds = additionalServices
      .map((item) => item.user_id)
      .filter((id): id is string => typeof id === "string");

    const profiles = this.log_errors(
      await this.client.from("profile").select("name, email, auth0_id").in("auth0_id", userIds),
    );
    if (profiles.error) return { error: rows.error, data: null };
    const profileMap = new Map(
      (profiles?.data ?? []).map((profile) => [profile.auth0_id, profile]),
    );

    const data = additionalServices.map((service) => {
      const userId = service.user_id;
      return {
        ...service,
        profile: userId ? profileMap.get(userId) : null,
      };
    });

    return { data, error: null };
  }
}
